export const SET_KACHELN = "setKacheln";
export const SET_SPRACHEN = "setSprachen"
